import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { Loading } from '../common/loading'
import ErrorCustom, { errorTypes } from '../errors/ErrorCustom'
import { SaveRoute } from '../layout/SaveRoute'
import { ValidateBoughtReport } from './ValidateBoughtReport'
import {
  selectIsLoadingHeaderCompanyAnalysis,
  selectIsRedirect404,
} from './common/header/companyInfo/store/slice'
import { getHeaderCompanyAnalysis } from './common/header/companyInfo/store/thunk'

export const ValidateOrgId = ({ children }) => {
  const dispatch = useDispatch()
  const location = useLocation()

  const locale = useSelector((state) => state.i18n.locale)
  const isRedirect404 = useSelector(selectIsRedirect404)
  const isLoadingHeaderCompanyAnalysis = useSelector(
    selectIsLoadingHeaderCompanyAnalysis,
  )

  const isFirstMount = useRef(true)

  const params = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  useEffect(() => {
    dispatch(
      getHeaderCompanyAnalysis({
        OrganizationId: params.organizationId,
      }),
    )
  }, [locale, params.organizationId])

  if (isLoadingHeaderCompanyAnalysis && isFirstMount.current) {
    isFirstMount.current = false
    return <Loading />
  }

  if (isRedirect404) {
    return isRedirect404 === errorTypes.FORBIDDEN.statusCode ? (
      <ErrorCustom errorType={errorTypes.FORBIDDEN} />
    ) : (
      <ErrorCustom errorType={errorTypes.NOT_FOUND_ORGANIZATION_ID} />
    )
  }

  return (
    <ValidateBoughtReport>
      <SaveRoute>{children}</SaveRoute>
    </ValidateBoughtReport>
  )
}
